import styles from './Statistic.module.css'
import {TextGradient} from "../../../../components/textGradient/TextGradient";
import {LGBTButton} from "../../../../components/lgbtButton/LGBTButton";
import {useNavigate, useNavigation} from "react-router-dom";
import {auth, getMainPage} from "..//../../../store/app-slice/AppSlice"
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { useEffect, useState } from 'react';
import { Modal } from '../../../../components/modal/Modal';
import { UpdateMoney } from '../updateMoney/UpdateMoney';
export const Statistic = ({isRegister=false,isAdmin}:{isRegister?:boolean,isAdmin?:boolean})=>{
    const navigation = useNavigate()
    const token = useAppSelector(state=>state.appStore.token);
    const mainData = useAppSelector(state=>state.appStore.maim)
    const dispatch:any = useAppDispatch();
    const [isUpdateMoneyOpen,setIsUpdateMoneyOpen]=useState<boolean>(false)
    useEffect(()=>{
            dispatch(getMainPage())
        
    },[])
    return (
        <div className={styles.statistic_container}>
            <div>
                <div>
                    <TextGradient
                        colors={["#739E72","#1C6A93","#F65B3E"]}
                        text={mainData.distance_length.toLocaleString('ru-RU')}
                        fontSize={"36px"}
                        fontWeigth={"700"}/>
                    <TextGradient
                        colors={["#739E72","#1C6A93","#F65B3E"]}
                        text={"ОБЩИЙ РЕЗУЛЬТАТ, КМ"}
                        fontSize={"14px"}
                        fontWeigth={"400"}/>
                </div>
                {!isRegister &&
                    (
                        <div style={{marginTop:"20px"}}>
                            <LGBTButton
                                text={"Участвовать"}
                                textColor={"white"}
                                textSize={"16px"}
                                onClick={()=>{navigation("/auth")}}/>
                        </div>
                        )
                    }
                <div className={styles.statistic_total}>
                    <div className={styles.statistic_total_item}>
                        <div className={styles.statistic_total_item_text_h1}>{mainData.count_user.toLocaleString('ru-RU')}</div>
                        <div className={styles.statistic_total_item_text_h2} style={{textAlign:"start"}}>участников</div>
                    </div>
                    <div className={styles.statistic_total_item}>
                        <div className={styles.statistic_total_item_text_h1} style={{textAlign:"end"}} onClick={()=> isAdmin==true&&setIsUpdateMoneyOpen(true)}>{mainData.amount.toLocaleString('ru-RU')}</div>
                        <div className={styles.statistic_total_item_text_h2} style={{textAlign:"end"}}>Собрали, ₽</div>
                    </div>
                </div>
            </div>
            {isUpdateMoneyOpen&&<Modal isOpen={true}>
                                <Modal.Content isClosable={true} onClose={()=>setIsUpdateMoneyOpen(false)}>
                                    <div>
                                        <UpdateMoney onResult={()=>setIsUpdateMoneyOpen(false)}/>
                                    </div>
                                </Modal.Content>
                             </Modal>}
        </div>
    )
}